import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PageSeo from '../components/seo/PageSeo';

const NotFound = () => {
  const location = useLocation();

  return (
    <main className="panel panel--spaced">
      <PageSeo
        title="Сторінку не знайдено | BigSPORT"
        description="Запитану сторінку BigSPORT не знайдено."
        canonicalPath={location.pathname}
        robots="noindex, nofollow"
      />
      <h1>Сторінку не знайдено</h1>
      <p>Можливо, адресу було змінено або сторінка більше не існує.</p>
      <Link to="/">Повернутися на головну</Link>
    </main>
  );
};

export default NotFound;
